import AssignmentAssistantScreen from 'src/views/lesson';
import AssignmentDuplicate from 'src/views/assignment/Duplicate';
import AssignmentHandout from 'src/views/assignment/Handout';
import CoteacherInvitation from 'src/views/register/CoteacherInvitation';
import AssignmentScreen from '../views/assignment';
import Register from '../views/register';
import StudentSignUp from '../views/register/StudentSignUp';
import TeacherSignUp from '../views/register/TeacherSignUp';
import SchoolDetected from '../views/register/SchoolDetected';
import FindSchool from '../views/register/FindSchool';
import SchoolInformation from '../views/register/SchoolInformation';
import SchoolValidation from '../views/register/SchoolValidation';
import SignIn from '../views/signIn';
import ResetPassword from '../views/resetPassword';
import BirthdayForm from '../views/register/BirthdayForm';
import GoogleEmail from '../views/register/GoogleEmail';
import JoinCode from '../views/register/JoinCode';
import DocumentScreenV2 from '../views/document-v2';
import PublishedPressto from '../views/publish';
import NewspaperReader from '../views/reader';
import GoogleRedirect from '../views/register/GoogleRedirect';
import LandingPage from '../views/landing';
import LandingPageV2 from '../views/landing/LandingPageV2';
import LandingPageV3 from '../views/landing/LandingPageV3';
import LandingPageV4 from '../views/landing/LandingPageV4';
import NewspaperLandingPage from '../views/landing/NewspaperLandingPage';
import RGRLandingPage from '../views/landing/RGRLandingPage';
import CurriculumDistrictPage from '../views/landing/CurriculumDistrictPage';
import CurriculumPublisherPage from '../views/landing/CurriculumPublisherPage';
import BritannicaPublisherPage from '../views/landing/BritannicaPublisherPage';
import NearpodPublisherPage from '../views/landing/NearpodPublisherPage';
import CurriculumGalleryPage from '../views/landing/CurriculumGalleryPage';
import WelcomeBackPage from '../views/landing/WelcomeBackPage';
import ForRGRPage from '../views/landing/ForRGRPage';
import FeaturesPage from '../views/landing/FeaturesPage';
import PricingPage from '../views/landing/PricingPage';
import ContactPage from '../views/landing/ContactPage';
import BlogPage from '../views/landing/BlogPage';
import BlogPostPage from '../views/landing/BlogPostPage';
import CheckoutSuccessPage from '../views/landing/CheckoutSuccessPage';

const PUBLIC_ROUTES = [
  {
    path: '/',
    name: 'Landing',
    component: LandingPageV4,
  },
  {
    path: '/homepage-v1',
    name: 'Landing V1 (previous)',
    component: LandingPage,
  },
  {
    path: '/homepage-v2',
    name: 'Landing V2',
    component: LandingPageV2,
  },
  {
    path: '/homepage-v3',
    name: 'Landing V3',
    component: LandingPageV3,
  },
  {
    path: '/homepage-v4',
    name: 'Landing V4',
    component: LandingPageV4,
  },
  {
    path: '/newspaper',
    name: 'Newspaper Landing',
    component: NewspaperLandingPage,
  },
  {
    path: '/curriculum',
    name: 'Curriculum Gallery',
    component: CurriculumGalleryPage,
  },
  {
    path: '/curriculum/rgr',
    name: 'RGR Landing',
    component: RGRLandingPage,
  },
  {
    path: '/curriculum/district/:slug',
    name: 'Curriculum District',
    component: CurriculumDistrictPage,
  },
  {
    path: '/curriculum/publisher/britannica',
    name: 'Britannica Partnership',
    component: BritannicaPublisherPage,
  },
  {
    path: '/curriculum/publisher/nearpod',
    name: 'Nearpod Partnership',
    component: NearpodPublisherPage,
  },
  {
    path: '/welcome-back',
    name: 'Welcome Back',
    component: WelcomeBackPage,
  },
  {
    path: '/curriculum/publisher/:slug',
    name: 'Curriculum Publisher',
    component: CurriculumPublisherPage,
  },
  {
    path: '/for-rgr',
    name: 'For RGR',
    component: ForRGRPage,
  },
  {
    path: '/features',
    name: 'Features',
    component: FeaturesPage,
  },
  {
    path: '/pricing',
    name: 'Pricing',
    component: PricingPage,
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactPage,
  },
  {
    path: '/blog',
    name: 'Blog',
    component: BlogPage,
  },
  {
    path: '/blog/:slug',
    name: 'BlogPost',
    component: BlogPostPage,
  },
  {
    path: '/checkout/success',
    name: 'Checkout Success',
    component: CheckoutSuccessPage,
  },
  {
    path: '/login',
    name: 'SignIn',
    component: SignIn,
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
  },
  {
    path: '/code/:joinCode?',
    name: 'Join Code Shortened',
    component: JoinCode,
  },
  {
    path: '/coteacher-invitation/:coteacherInvitationId?',
    name: 'Co-Teacher Invitation',
    component: CoteacherInvitation,
  },
  {
    path: '/register-student',
    name: 'Register Student',
    component: StudentSignUp,
  },
  {
    path: '/register-teacher',
    name: 'Register Teacher',
    component: TeacherSignUp,
  },
  {
    path: '/school-detected',
    name: 'School Detected',
    component: SchoolDetected,
  },
  {
    path: '/find-school',
    name: 'Find School',
    component: FindSchool,
  },
  {
    path: '/school-information',
    name: 'School Information',
    component: SchoolInformation,
  },
  {
    path: '/school-validation',
    name: 'School Validation',
    component: SchoolValidation,
  },
  {
    path: '/reset-password',
    name: 'Reset Password',
    component: ResetPassword,
  },
  {
    path: '/birthday-form',
    name: 'Birthday Form',
    component: BirthdayForm,
  },
  {
    path: '/document/:id/',
    name: 'Document',
    component: DocumentScreenV2,
  },
  {
    path: '/document/:id/pages/:pageIndex',
    name: 'Document Page',
    component: DocumentScreenV2,
  },
  {
    path: '/publish/:id',
    name: 'Published Pressto',
    component: DocumentScreenV2,
  },
  {
    path: '/publish-l/:id',
    name: 'Published Pressto',
    component: PublishedPressto,
  },
  {
    path: '/document/:id/',
    name: 'Document',
    component: DocumentScreenV2,
  },
  {
    path: '/assignment/:id/duplicate',
    name: 'Assignment',
    component: AssignmentDuplicate,
  },
  {
    path: '/assignment/:id/handout',
    name: 'Assignment Handout',
    component: AssignmentHandout,
  },
  {
    path: '/assignment/:id',
    name: 'Assignment',
    component: AssignmentScreen,
  },
  {
    // This is the URL used for sharing assignments with others. It may become
    // more distinct from the assignment route in the future, but for now it
    // shares the same code as AssignmentScreen.
    path: '/templates/:id',
    name: 'Assignment Template',
    component: AssignmentScreen,
  },
  {
    path: '/assistant',
    name: 'AssignmentAssistant',
    component: AssignmentAssistantScreen,
  },
  {
    path: '/document/:id/pages/:pageIndex',
    name: 'Document',
    component: DocumentScreenV2,
  },
  {
    path: '/google-email',
    name: 'Google Email',
    component: GoogleEmail,
  },

  // React router v6 doesn't support optional parameter,
  // so the solution is to create two similar routes
  // https://github.com/remix-run/react-router/issues/7285#issuecomment-620071853
  {
    path: '/oauth/google',
    name: 'Google Redirect',
    component: GoogleRedirect,
  },
  {
    path: '/oauth/google/:type',
    name: 'Google Redirect',
    component: GoogleRedirect,
  },
  {
    path: '/try-it',
    name: 'Try It',
    component: DocumentScreenV2,
  },
  {
    path: '/read/:slug',
    name: 'Newspaper Reader',
    component: NewspaperReader,
  },
];

export default PUBLIC_ROUTES;
